import React, { Component } from 'react';

import { Capsule, Capsules, CapuseleController } from './styles';
import { LinkTag } from '../../Buttons/Buttons';
import { amountFormatter } from '../../../utils';
import { TooltipContainer } from '../../../../../CommonComponents/Info/Tooltip/styles';
import PropTypes from 'prop-types';

function generateCapsule(type, filter) {
  if (type === 'Balance') {
    return `${type}(${amountFormatter(filter.selectedMin)} - ${amountFormatter(
      filter.selectedMax
    )})`;
  } else if (type === 'Year Opened') {
    return `${type}(${filter.selectedMin} - ${filter.selectedMax})`;
  } else if (type === 'States') {
    let choices = filter.selectedVal;
    return `${type} - ${choices.join(',')}`;
  } else if (type === 'Designated Role') {
    return `${type} - ${filter.selectedVal}`;
  }
}
class FilterCapsule extends Component {
  render() {
    let checkFlag = false;
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    let updatedFilters = this.props.filters;
    for (let itr = 0; itr < updatedFilters.length; itr++) {
      if (updatedFilters[itr].applicable === true) {
        checkFlag = true;
        break;
      }
    }
    const capsules = this.props.filters.map((capsule, index) =>
      capsule.applicable ? (
        <Capsule
          data-test = "capsule"
          closable
          visible={capsule.visible}
          onClose={() => this.props.closeFilter(capsule)}
          isSafari
        >
          <TooltipContainer
            className='dashboard-ellipsis'
            placement='topLeft'
            title={generateCapsule(capsule.type, capsule)}
          >
            <CapuseleController
              mobileView={
                isSafari
                  ? window.innerWidth > 767
                    ? false
                    : true
                  : window.screen.availWidth > 767
                  ? false
                  : true
              }
            >
              {capsule.applicable
                ? generateCapsule(capsule.type, capsule)
                : null}
            </CapuseleController>
          </TooltipContainer>
        </Capsule>
      ) : null
    );
    return checkFlag ? (
      <Capsules>
        {capsules}
        <LinkTag name='Clear All' clicked={this.props.cleared} />
      </Capsules>
    ) : null;
  }
}
FilterCapsule.propTypes = {
  cleared: PropTypes.func,
  closeFilter: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.object),
};
export default FilterCapsule;
